var Form = function (options) {
	this.options = {
		$el: false,
		baseClass: 'el-Form',
	};

	$.extend(true, this.options, options);
};

Form.prototype.init = function () {
	const self = this;

	// self.$form = self.options.$el.find(`.${self.options.baseClass}__form`);
	// self.$defaultSubmitButton = self.$form.find('.fui-submit');
	// self.$customSubmitButton = self.options.$el.find(
	// 	`.${self.options.baseClass}__form__submit`,
	// );

	// self.options.$el.find('.fui-i').removeClass('fui-i');

	// self.handleSubmitButtonSwap();
	// self.initSelectDropdowns();
	
	// Add Webflow classes to Formie markup for styling compatibility
	self.addWebflowClasses();
	
	// Apply Now functionality is now handled by Modal trigger system
	// No need for PubSub subscriptions
};

// Apply Now functionality is now handled by Modal trigger system
// See Modal.js initTriggers() for the implementation

Form.prototype.handleSubmitButtonSwap = function () {
	const self = this;

	if (!self.$customSubmitButton.length && !self.$defaultSubmitButton.length)
		return;

	let submitButtonText = self.$defaultSubmitButton.html();
	self.$customSubmitButton.find(`.atom-ButtonPrimary__text`).html(submitButtonText);

	self.$defaultSubmitButton.hide();
	self.$customSubmitButton.show().insertAfter(self.$defaultSubmitButton);

	self.$form.find(self.$customSubmitButton).on('click', (e) => {
		self.$defaultSubmitButton.click();
	});
};

Form.prototype.initSelectDropdowns = function(){

	const self = this;

    self.options.$el.find('select').on('change', function() {

        $(this).removeClass('value-selected');

        if ($(this).val() != '')
        {
            $(this).addClass('value-selected');
        }

    });

};

/**
 * Add Webflow form classes to Formie markup for styling compatibility
 * This allows the existing Webflow CSS to apply to Formie forms
 */
Form.prototype.addWebflowClasses = function () {
	const self = this;
	const $form = self.options.$el.find('.fui-i');

	if (!$form.length) return;

	// Add form_form class to form container
	$form.addClass('form_form w-form');

	// Map Formie classes to Webflow classes
	const classMappings = {
		'.fui-field': 'form_field-wrapper',
		'.fui-label': 'form_field-label',
		'.fui-input': 'form_input w-input',
		'.fui-textarea': 'form_input is-text-area w-input',
		'.fui-select': 'form_input is-select-input w-select',
		'.fui-submit, .fui-btn': 'button is-submit w-button',
		'.fui-checkbox': 'form_checkbox',
		'.fui-radio': 'form_radio w-radio',
		'.fui-checkbox-label': 'form_checkbox-label w-form-label',
		'.fui-radio-label': 'form_radio-label w-form-label',
	};

	// Apply class mappings
	Object.keys(classMappings).forEach((formieSelector) => {
		const webflowClasses = classMappings[formieSelector];
		$form.find(formieSelector).addClass(webflowClasses);
	});

	// Target submit buttons - both Formie classes and actual button/input elements
	$form.find('.fui-submit, .fui-btn, input[type="submit"], button[type="submit"]').addClass('button is-submit w-button');

	// Handle 2-column layouts
	$form.find('.fui-row.fui-row-2-col').addClass('form_field-2col');

	// Handle select full-width
	$form.find('.fui-select').each(function() {
		const $select = $(this);
		if ($select.closest('.fui-field').hasClass('fui-field-full-width')) {
			$select.addClass('is-full-width');
		}
	});

	// Add checkbox/radio icon classes
	$form.find('.fui-checkbox-input').addClass('w-checkbox-input w-checkbox-input--inputType-custom form_checkbox-icon');
	$form.find('.fui-radio-input').addClass('w-form-formradioinput w-form-formradioinput--inputType-custom form_radio-icon w-radio-input');
};

export default Form;